import React from 'react';
import { ChevronRight } from 'lucide-react';
import { STEP_CONFIGS } from '../../stores/useWorkflowStore';
import { cn } from '../../lib/utils';

const BreadcrumbChevron = () => (
  <ChevronRight
    size={14}
    strokeWidth={2}
    aria-hidden
    className="mx-1.5 shrink-0 text-neutral-300"
  />
);

const StepBreadcrumb = ({
  processLabel,
  workflowSteps,
  currentStep,
  stepCompletion,
  canNavigateToStep,
  onStepClick,
}) => {
  if (!processLabel && !workflowSteps?.length) return null;

  const subSteps = workflowSteps.filter((step) => {
    const label = STEP_CONFIGS[step]?.label || step;
    return !(workflowSteps.length === 1 && label === processLabel);
  });

  return (
    <nav
      className="flex min-w-0 flex-1 items-center overflow-x-auto overflow-y-hidden [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      aria-label="Design workflow"
    >
      <ol className="m-0 flex list-none items-center gap-0 p-0">
        {processLabel && (
          <li className="flex shrink-0 items-center">
            <span className="whitespace-nowrap text-base font-medium text-neutral-600">
              {processLabel}
            </span>
          </li>
        )}

        {subSteps.map((step) => {
          const isActive = step === currentStep;
          const isAccessible = canNavigateToStep(step);
          const label = STEP_CONFIGS[step]?.label || step;

          return (
            <li key={step} className="flex shrink-0 items-center">
              <BreadcrumbChevron />
              {isAccessible && !isActive ? (
                <button
                  type="button"
                  onClick={() => onStepClick(step)}
                  className="cursor-pointer border-0 bg-transparent p-0 text-sm font-medium text-neutral-700 transition-colors hover:text-neutral-800 focus-visible:rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--focus-ring,#0070f3)] focus-visible:outline-offset-2"
                >
                  {label}
                </button>
              ) : (
                <span
                  className={cn(
                    'whitespace-nowrap text-sm',
                    isActive
                      ? 'font-medium text-odp-purple-light'
                      : 'font-normal text-neutral-400',
                    stepCompletion[step] && !isActive && 'text-neutral-500'
                  )}
                  aria-current={isActive ? 'step' : undefined}
                >
                  {label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default StepBreadcrumb;
